import { WebglObject } from "./webgl-object";

export class Rectangle extends WebglObject {
  constructor(settings) {
    super(settings);
    if (this.settings.hasFill === undefined) {
      this.settings.hasFill = false; 
    }
    if (this.settings.hasStroke === undefined) {
      this.settings.hasStroke = false; 
    }
    if (this.settings.fillColor === undefined) {
      this.settings.fillColor = [0, 0, 0, 1]; 
    }
    if (this.settings.strokeColor === undefined) {
      this.settings.strokeColor = [0, 0, 0, 1]; 
    }

    if (this.settings.hasFill || this.settings.hasStroke) {
      this.uniforms = {
        u_color: new Float32Array(this.settings.fillColor),
        u_shift: new Float32Array([0.0, 0.0]),
        u_rollIndex: 0,
        u_scale: new Float32Array([1, 1]),
        u_windowSize: new Float32Array([this.settings.canvas.settings.sizeInPixels.width, this.settings.canvas.settings.sizeInPixels.height])
      };
      const gl = this.settings.gl;
      if (this.settings.hasFill) {
        this.fillBuffer = WebglObject.createRectangleFillBuffer(this.settings.absoluteLocation, this.settings.sizeInPixels);
        this.fillIndices = new Uint16Array([3, 2, 1, 3, 1, 0]);

        this.fillVerticesBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.fillVerticesBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.fillBuffer, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);

        this.fillIndicesBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.fillIndicesBuffer);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, this.fillIndices, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, null);
      }
      if (this.settings.hasStroke) {
        this.strokeBuffer = WebglObject.createRectangleStrokeBuffer(this.settings.absoluteLocation, this.settings.sizeInPixels);
        this.strokeVerticesBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.strokeVerticesBuffer);
        gl.bufferData(gl.ARRAY_BUFFER, this.strokeBuffer, gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
      }
    }
  }

  createBorders() {
    super.createBorders();
    this.updateDataBuffer();
  }

  updateDataBuffer() {
    this.uniforms.u_windowSize = new Float32Array([this.settings.canvas.settings.sizeInPixels.width, this.settings.canvas.settings.sizeInPixels.height]);
    const gl = this.settings.gl;
    if (this.settings.hasFill) {
      this.fillBuffer = WebglObject.createRectangleFillBuffer(this.settings.absoluteLocation, this.settings.sizeInPixels);
      gl.bindBuffer(gl.ARRAY_BUFFER, this.fillVerticesBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, this.fillBuffer, gl.STATIC_DRAW);
    }

    if (this.settings.hasStroke) {
      this.strokeBuffer = WebglObject.createRectangleStrokeBuffer(this.settings.absoluteLocation, this.settings.sizeInPixels);
      gl.bindBuffer(gl.ARRAY_BUFFER, this.strokeVerticesBuffer);
      gl.bufferData(gl.ARRAY_BUFFER, this.strokeBuffer, gl.STATIC_DRAW);
    }
  }

  draw(gl, program) {
    if (this.settings.hasFill || this.settings.hasStroke) {
      gl.viewport(0, 0, this.uniforms.u_windowSize[0], this.uniforms.u_windowSize[1]);
      if (this.settings.hasFill) {
        this.uniforms.u_color = new Float32Array(this.settings.fillColor);
        program.setUnforms(this.uniforms);
        gl.enableVertexAttribArray(program.attribs.a_position);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.fillVerticesBuffer);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.fillIndicesBuffer);
        gl.vertexAttribPointer(program.attribs.a_position, 2, gl.FLOAT, false, 0, 0);
        gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
      } else if (this.settings.hasStroke) {
        gl.enableVertexAttribArray(program.attribs.a_position);
      }
      if (this.settings.hasStroke) {
        this.uniforms.u_color = new Float32Array(this.settings.strokeColor);
        program.setUnforms(this.uniforms);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.strokeVerticesBuffer);
        gl.vertexAttribPointer(program.attribs.a_position, 2, gl.FLOAT, false, 0, 0);
        gl.drawArrays(gl.LINES, 0, this.strokeBuffer.length / 2);
      }
    }
  }
}
